import { ExchangeRate } from '../ui';

export function RatesPage() {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-6">
        <h2 className="flex-1 text-2xl font-bold">Курсы валют</h2>
        <ExchangeRate />
      </div>
    </div>
  );
}
